import React, { FC, Dispatch, SetStateAction } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'

const SeeMoreArtworksCarousel = dynamic(
  import(
    /* webpackChunkName: "SeeMoreArtworksCarousel" */
    './Carousel'
  ),
  noSSR
)

const SeeMoreArtworks: FC = () => {
  return <SeeMoreArtworksCarousel />
}

export default SeeMoreArtworks
